import { Item, ItemActions, ItemDescription, ItemHeader, ItemTitle } from '@ibsys/kit';
import { TruncatedText } from '@/shared/ui';
import { ReactNode } from 'react';
import { cn } from '@/shared/lib';

type NestedItemCardProps<T> = {
  item: T;
  renderTitle: (item: T) => ReactNode;
  renderDescription?: (item: T) => ReactNode;
  action?: ReactNode;
  className?: string;
};

/** Строка состава вложенного списка — одна и та же и в самом списке карточки, и в окне выбора. */
export const NestedItemCard = <T,>({
  item,
  renderTitle,
  renderDescription,
  action,
  className,
}: NestedItemCardProps<T>) => {
  return (
    <Item variant="outline" className={cn('min-w-0', className)} size={'sm'}>
      <ItemHeader className="min-w-0">
        <ItemTitle className="min-w-0 wrap-break-word">{renderTitle(item)}</ItemTitle>
        {action && <ItemActions className="ml-4 shrink-0">{action}</ItemActions>}
      </ItemHeader>
      {renderDescription && (
        <ItemDescription className="min-w-0 text-sm text-muted-foreground">
          <TruncatedText>{renderDescription(item)}</TruncatedText>
        </ItemDescription>
      )}
    </Item>
  );
};
